/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: LqMwNzsXjkO-
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicLeftSectionNav.module.css"; // plasmic-import: LqMwNzsXjkO-/css

createPlasmicElementProxy;

export const PlasmicLeftSectionNav__VariantProps = new Array(
  "topNav",
  "bottomNav"
);

export const PlasmicLeftSectionNav__ArgProps = new Array(
  "children",
  "currentPageTitle"
);

const $$ = {};

function PlasmicLeftSectionNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "topNav",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.topNav
      },
      {
        path: "bottomNav",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.bottomNav
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootbottomNav_defaultOnboarding]: hasVariant(
            $state,
            "bottomNav",
            "defaultOnboarding"
          ),
          [sty.rootbottomNav_noLeftPadding]: hasVariant(
            $state,
            "bottomNav",
            "noLeftPadding"
          ),
          [sty.roottopNav_titleAndOneCrumb]: hasVariant(
            $state,
            "topNav",
            "titleAndOneCrumb"
          )
        }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox___9TKbK, {
          [sty.freeBoxbottomNav_defaultOnboarding___9TKbK33QGr]: hasVariant(
            $state,
            "bottomNav",
            "defaultOnboarding"
          ),
          [sty.freeBoxbottomNav_noLeftPadding___9TKbKkQf80]: hasVariant(
            $state,
            "bottomNav",
            "noLeftPadding"
          ),
          [sty.freeBoxtopNav_titleAndOneCrumb___9TKbKOnQB]: hasVariant(
            $state,
            "topNav",
            "titleAndOneCrumb"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Enter some text",
          value: args.children,
          className: classNames(sty.slotTargetChildren, {
            [sty.slotTargetChildrenbottomNav_defaultOnboarding]: hasVariant(
              $state,
              "bottomNav",
              "defaultOnboarding"
            ),
            [sty.slotTargetChildrenbottomNav_noLeftPadding]: hasVariant(
              $state,
              "bottomNav",
              "noLeftPadding"
            ),
            [sty.slotTargetChildrentopNav_tabTitle]: hasVariant(
              $state,
              "topNav",
              "tabTitle"
            ),
            [sty.slotTargetChildrentopNav_titleAndOneCrumb]: hasVariant(
              $state,
              "topNav",
              "titleAndOneCrumb"
            )
          })
        })}
      </div>
      {(hasVariant($state, "topNav", "titleAndOneCrumb") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__pDfsu, {
            [sty.freeBoxtopNav_titleAndOneCrumb__pDfsuOnQB]: hasVariant(
              $state,
              "topNav",
              "titleAndOneCrumb"
            )
          })}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"/"}
          </div>
        </div>
      ) : null}
      {(hasVariant($state, "topNav", "titleAndOneCrumb") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__dkC6Y, {
            [sty.freeBoxtopNav_titleAndOneCrumb__dkC6YOnQB]: hasVariant(
              $state,
              "topNav",
              "titleAndOneCrumb"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: "enter some text",
            value: args.currentPageTitle,
            className: classNames(sty.slotTargetCurrentPageTitle, {
              [sty.slotTargetCurrentPageTitletopNav_titleAndOneCrumb]:
                hasVariant($state, "topNav", "titleAndOneCrumb")
            })
          })}
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLeftSectionNav__ArgProps,
          internalVariantPropNames: PlasmicLeftSectionNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLeftSectionNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLeftSectionNav";
  } else {
    func.displayName = `PlasmicLeftSectionNav.${nodeName}`;
  }
  return func;
}

export const PlasmicLeftSectionNav = Object.assign(
  // Top-level PlasmicLeftSectionNav renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicLeftSectionNav
    internalVariantProps: PlasmicLeftSectionNav__VariantProps,
    internalArgProps: PlasmicLeftSectionNav__ArgProps
  }
);

export default PlasmicLeftSectionNav;
/* prettier-ignore-end */
